/* eslint-disable no-underscore-dangle */
export const proxy = (command, context, ...args) => {
	const hasArgs = args.length;
	const wrapper = (...proxyArgs) => command.apply(context,
		hasArgs ? args.concat(proxyArgs) : proxyArgs,
	);
	wrapper.__bind__ = wrapper.__bind__ || command;
	return wrapper;
};

export default proxy;
